export default __webpack_public_path__ + "static/0016-4424d4a6961acc0a0b01ae066f7a4dba.png";